import React from 'react';

import {
  OfferBadgeBackground,
  Offers,
  styled,
} from '@vw-marketing/us-components';

const StyledContainer = styled.div`
  position: relative;
  display: inline-block;
  color: #FFD100;
`;

const StyledOffers = styled(Offers)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #001E50;
`;

export const BadgeIcon = () => {
  return (
    <StyledContainer>
      <OfferBadgeBackground />
      <StyledOffers variant="small" />
    </StyledContainer>
  );
};
